import { render, staticRenderFns } from "./ProjectConnectionDetails.vue?vue&type=template&id=11e03a64&scoped=true&"
import script from "./ProjectConnectionDetails.vue?vue&type=script&lang=js&"
export * from "./ProjectConnectionDetails.vue?vue&type=script&lang=js&"
import style0 from "./ProjectConnectionDetails.vue?vue&type=style&index=0&id=11e03a64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e03a64",
  null
  
)

export default component.exports